import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation, ExcCoreModule} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {UserSettingsService} from '../../../../services/user-settings.service';

@Component({
  selector: 'app-sv-user-stempel',
  templateUrl: './sv-user-stempel.component.html',
  styles: []
})
export class SvUserStempelComponent extends ExcTranslation implements OnInit {
  private _data: any;

  @Input()
  set data(value: any) {
    this._data = value;
    this.reload();
  }
  get data(): any {
    return this._data;
  }

  excRestService = ExcCoreModule.Services().ExcRest;

  list: any[] = [];
  state = 1; // 1=loading, 0=data, 2=empty
  saving = false;

  upload: {
    preview: string;
    base64: string;
    mimeType: string;
    name: string;
    error: string;
  } = {preview: '', base64: '', mimeType: '', name: '', error: ''};

  constructor(
    private modalService: ExgModalService,
    private userSettings: UserSettingsService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  reload(): void {
    if (this._data) {
      this.load();
    }
  }

  load(): void {
    this.state = 1;
    this.excRestService
      .sget(
        this.excRestService.computeUrl('UserStempelR_List', null),
        ExcCoreModule.Guid.NewGuid(),
        {}
      )
      .subscribe((ret: any) => {
        if (ret.success && ret.data?.UserStempel) {
          this.list = ret.data.UserStempel;
          this.state = this.list.length > 0 ? 0 : 2;
        } else {
          this.state = 2;
        }
      });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (!file) {
      return;
    }
    const fileSize = 512 * 1024; // 512kb todo filetable?

    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      const result = e.target?.result as string;
      this.upload.preview = result;
      this.upload.base64 = result;
      this.upload.mimeType = file.type;
      this.upload.name = file.name.replace(/\.[^.]+$/, '');
    };
    reader.readAsDataURL(file);
  }

  cancelUpload(): void {
    this.upload = {preview: '', base64: '', mimeType: '', name: '', error: ''};
  }

  save(): void {
    if (!this.upload.name || !this.upload.base64 || this.saving) {
      return;
    }
    this.saving = true;
    this.excRestService
      .post(
        this.excRestService.computeUrl('UserStempelC', null),
        {
          stpName: this.upload.name,
          stpData: this.upload.base64,
          stpMimeType: this.upload.mimeType,
        }
      )
      .subscribe((ret: any) => {
        this.saving = false;
        if (ret.success) {
          this.modalService.showToast(
            this.getRessource('Toast.UploadSuccess'),
            'md-toast',
            'far fa-stamp'
          );
          this.cancelUpload();
          this.load();
          this.userSettings.loadStempel();
        }
      });
  }
// todo
  confirmDelete(s: any): void {
    this.modalService
      .showSimple(
        this.getRessource('Toast.Delete'),
        `"${s.stpName}" ${this.getRessource('Toast.ConfirmDelete')}`,
        true,
        true,
        this.getGlobal('Delete'),
        this.getGlobal('Cancel'),
      )
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.delete(s);
        }
      });
  }
  delete(s: any): void {
    this.excRestService
      .delete(
        this.excRestService.computeUrl('UserStempelD', {stpID: s.stpID}),
        {}
      )
      .subscribe((ret: any) => {
        if (ret.success) {
          this.modalService.showToast(
            this.getRessource('Toast.Deleted'),
            'md-toast',
            'far fa-trash'
          );
          this.load();
          this.userSettings.loadStempel();
        }
      });
  }
  previewStempel(s: any): void {
    this.modalService.show('ModalImageViewerComponent', {
      otherMime: [{
        dokID: s.stpID,
        dokMIME: s.stpMimeType,
        dokName: s.stpName
      }],
      attID: s.stpID,
      stempelPreview: true
    }).subscribe();
  }

  renameStempel(s: any): void {
    s._renaming = true;
    s._newName = s.stpName;
  }

  saveRename(s: any): void {
    if (!s._newName || s._newName === s.stpName) {
      s._renaming = false;
      return;
    }
    this.excRestService
      .put(
        this.excRestService.computeUrl('UserStempelU', {stpID: s.stpID}), {stpName: s._newName}
      )
      .subscribe((ret: any) => {
        if (ret.success) {
          this.list = ret.data.UserStempel;
          this.userSettings.loadStempel();
          this.modalService.showToast(
            this.getRessource('Toast.Renamed'),
            'md-toast',
            'far fa-stamp'
          );
        }
        s._renaming = false;
      });
  }
}
